module.exports = __webpack_public_path__ + "app-static/img/user-icon.d133374e.jpg";